// frontend/modules/drafts/views/DraftResumeView.tsx
import React, { useEffect } from 'react';
import { useParams, useNavigate } from 'react-router-dom';
import { Typography, Alert, Spin, Button } from 'antd';
import { ArrowLeftOutlined } from '@ant-design/icons';
import { useDrafts } from '../hooks/useDrafts';
import DraftProcessHandler from '../components/DraftProcessHandler';
import { DraftProcessHandlerRegistry } from '../types/handlers';

const DraftResumeView: React.FC = () => {
  const { id } = useParams<{ id: string }>();
  const navigate = useNavigate();
  
  const {
    draftProcesses,
    isLoading,
    error,
    loadDraftProcesses,
    setActiveDraftProcess
  } = useDrafts();

  // Get handlers from the registry
  const draftHandlers = DraftProcessHandlerRegistry.getInstance().getHandlers();

  useEffect(() => {
    const loadDraft = async () => {
      await loadDraftProcesses();
      
      if (id && draftProcesses.length > 0) {
        const draft = draftProcesses.find(d => d.id === id);
        if (draft) {
          setActiveDraftProcess(draft);
        }
      }
    };
    
    loadDraft();
  }, [id, draftProcesses.length, loadDraftProcesses, setActiveDraftProcess]);

  if (isLoading) {
    return (
      <div className="flex justify-center p-4">
        <Spin size="large" tip="Loading draft process..." />
      </div>
    );
  }

  if (error) {
    return (
      <div className="space-y-4">
        <Button 
          icon={<ArrowLeftOutlined />} 
          onClick={() => navigate('/drafts')}
        >
          Back to Drafts
        </Button>
        
        <Alert
          message="Error"
          description={`Failed to load draft process: ${error}`}
          type="error"
          showIcon
        />
      </div>
    );
  }

  return (
    <div className="space-y-4">
      <Button 
        icon={<ArrowLeftOutlined />} 
        onClick={() => navigate('/drafts')}
      >
        Back to Drafts
      </Button>
      
      <DraftProcessHandler handlers={draftHandlers} />
    </div>
  );
};

export default DraftResumeView;
